import { Component, OnInit, Signal, inject } from '@angular/core';
import { dispatch, select } from '@store/injectables';
import { Pmo } from '@scenario/models/pmo.model';
import {
  PmoViewModel,
  deletePmo,
  retrievePmos,
  selectPmoViewModel,
} from '@store/scenario/pmo/pmo-slice';
import { ButtonComponent, IconComponent, ModalService } from '@totalenergiescode/tds-angular';
import { PmoFormModalComponent } from '../pmo-form-modal/pmo-form-modal.component';

@Component({
  selector: 'app-manage-pmo',
  templateUrl: './manage-pmo.component.html',
  styleUrl: './manage-pmo.component.scss',
  imports: [ButtonComponent, IconComponent],
})
export class ManagePmoComponent implements OnInit {
  private readonly dispatch = dispatch();
  private readonly modalService = inject(ModalService);
  public readonly pmoViewModel: Signal<PmoViewModel> = select(selectPmoViewModel);

  ngOnInit(): void {
    this.dispatch(retrievePmos());
  }

  zoneLabels(pmo: Pmo): string {
    return pmo.zones.map(zone => zone.alias).join(', ');
  }

  sourceLabels(pmo: Pmo): string {
    return pmo.sources.map(source => source.name).join(', ');
  }

  releaseLabels(pmo: Pmo): string {
    return pmo.sourcePublicationDates.join(', ');
  }

  openCreate(): void {
    this.modalService.open({ content: { component: PmoFormModalComponent } });
  }

  openEdit(pmo: Pmo): void {
    this.modalService.open({ content: { component: PmoFormModalComponent, inputs: { pmo } } });
  }

  remove(pmo: Pmo): void {
    if (pmo.id !== undefined && confirm(`Delete PMO ${pmo.id}?`)) {
      this.dispatch(deletePmo(pmo.id));
    }
  }
}



